// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d3ee3383","703":"0e023c89"}[chunkId] + ".chunk.js";
};